import React, { useContext } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './assets/fa/all.min.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import WelcomeView from './views/WelcomeView.tsx'
import AuthView from './views/auth/AuthView.tsx'
import HomeView from './views/home/HomeView.tsx'
// import AppFooter from './components/ui/AppFooter.tsx'
import AppHeader from './components/ui/AppHeader.tsx'
import HistoryView from './views/HistoryView.tsx'
import DebtView from './views/DebtView.tsx'
import PaymentView from './views/payment/PaymentView.tsx'
import RefundView from './views/RefundView.tsx'
import GuaranteeView from './views/guarantee/GuaranteeView.tsx'
import ContactView from './views/ContactView.tsx'
import FailedView from './views/failed/FailedView.tsx'
import SuccessView from './views/success/SuccessView.tsx'
import UserProvider from './provider/UserProvider.tsx'
import { UserContext } from './context/UserContext.tsx'

const router = createBrowserRouter([
  { path: '/welcome', element: <WelcomeView /> },
  { path: '/auth', element: <AuthView /> },
  { path: '/home', element: <HomeView /> },
  { path: '/', element: <HomeView /> },
  { path: '/history', element: <HistoryView /> },
  { path: '/debt', element: <DebtView /> },
  { path: '/payment', element: <PaymentView /> },
  { path: '/refund', element: <RefundView /> },
  { path: '/guarantee', element: <GuaranteeView /> },
  { path: '/contact', element: <ContactView /> },
  { path: '/failed', element: <FailedView /> },
  { path: '/success', element: <SuccessView /> }
])

const App: React.FC = () => {
  const context = useContext(UserContext)

  if (!context?.currentUser && location.pathname !== '/auth') {
    return <div>Загрузка...</div>
  }

  return (
    <>
      {location.pathname !== '/auth' && <AppHeader />}
      <RouterProvider router={router} />
    </>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
    {/*<UserProvider>*/}
    {/*  {location.pathname !== '/auth' && <AppHeader />}*/}
    {/*  <RouterProvider router={router} />*/}
    {/*  /!* <AppFooter /> *!/*/}
    {/*</UserProvider>*/}
  </React.StrictMode>
)
